import { IApplyForPublicationRequest } from '../../../../../repositories/coworking/v1/apply-for-publication';

import { TPlacementApplicationFormState } from '../../../CoworkingPlacementApplicationForm';

export function normalizePlacementApplicationFormFields(
  placementApplicationFormState: TPlacementApplicationFormState,
): IApplyForPublicationRequest {
  const { companyName, companyType, email, phone } = placementApplicationFormState;

  return {
    companyName: companyName.value,
    companyType: companyType.value,
    email: email.value,
    phone: phone.value,
  };
}
